import {POST, GET} from "@/services/gateway";

const list = () => {
  return GET('seat/backupsetings');
}

const updateAutoAdd = ({seatType, autoAdd, includeUnlicensed}) => {
  return POST('seat/backupsetings', {
    seatType, autoAdd, includeUnlicensed
  })
}


export {
  list,
  updateAutoAdd
}
